import React from "react";
import { Link } from "react-router-dom";

// Discrete bottom-of-page link that takes the visitor to the consultation page.
// Used at the end of every content page (not on the consultation page itself).
export default function NextPageCTA({ testId = "next-page-cta" }) {
  return (
    <section
      data-testid={testId}
      className="bg-warm border-t border-hairline px-6 md:px-10 py-14 md:py-20"
    >
      <div className="max-w-2xl mx-auto text-center">
        <p className="text-[11px] tracking-[0.35em] uppercase text-muted-warm font-body mb-5">
          — A következő lépés
        </p>
        <p className="font-serif-display italic text-graphite text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] max-w-xl mx-auto mb-9">
          Ha valami megérintett, és érzed, hogy ideje továbblépni,
          <br className="hidden md:block" /> várlak egy közös beszélgetésre.
        </p>
        <Link
          to="/konzultacio"
          data-testid={`${testId}-link`}
          className="inline-flex items-center gap-3 text-[12px] tracking-[0.3em] uppercase text-graphite hover:text-gold transition-colors duration-300 font-body pb-1 border-b border-gold"
        >
          Tovább a konzultációra
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </section>
  );
}
